import moment from 'moment-timezone'

import { calendarDate } from 'event-taxonomy'

export const DAYS_IN_WEEK = 7

export const monthKey = month => moment(month).format('YYYY-MM')
export const dayKey = date => moment(date).format('YYYY-MM-DD')

/**
 * Weeks of `{ date, inMonth, isToday }` covering the whole month, padded out to
 * full weeks at both ends so the grid is rectangular.
 */
export const buildMonthMatrix = (month, now = moment()) => {
  const start = moment(month).startOf('month').startOf('week')
  const end = moment(month).endOf('month').endOf('week')
  const cursor = start.clone()
  const weeks = []

  while (cursor.isSameOrBefore(end, 'day')) {
    const week = []

    for (let i = 0; i < DAYS_IN_WEEK; i++) {
      week.push({
        date: cursor.clone(),
        inMonth: cursor.isSame(moment(month), 'month'),
        isToday: cursor.isSame(now, 'day')
      })
      cursor.add(1, 'day')
    }

    weeks.push(week)
  }

  return weeks
}

/**
 * Buckets events by local calendar day. Local rather than UTC because that is
 * what the cards display — a 7pm ET webinar belongs on its ET date.
 */
export const groupByDay = events =>
  (events || []).reduce((acc, event) => {
    const date = calendarDate(event)
    if (!date) return acc

    const key = dayKey(date)
    acc[key] = (acc[key] || []).concat(event)
    return acc
  }, {})

export const eventsInMonth = (grouped, month) =>
  Object.keys(grouped)
    .filter(key => moment(key, 'YYYY-MM-DD').isSame(moment(month), 'month'))
    .reduce((total, key) => total + grouped[key].length, 0)
